{
  "name": "@backbase/ui-ang",
  "version": "16.0.0-beta.10",
  "description": "Backbase UI Components",
  "peerDependencies": {
    "@angular/animations": "^22 || ^23",
    "@angular/cdk": "^22 || ^23",
    "@angular/core": "^22 || ^23",
    "@angular/common": "^22 || ^23",
    "@angular/compiler": "^22 || ^23",
    "@angular/forms": "^22 || ^23",
    "@angular/localize": "^22 || ^23",
    "@angular/platform-browser": "^22 || ^23",
    "@angular/router": "^22 || ^23",
    "@ngx-formly/core": "^6.3.12",
    "@ng-bootstrap/ng-bootstrap": "^21 || ^22",
    "@ng-select/ng-select": "^24 || ^25",
    "@popperjs/core": "^2.11.8",
    "bignumber.js": "^9.0.1",
    "bootstrap": "~5.3.2",
    "ngx-mask": "^22 || ^23",
    "ngx-quill": "^31 || ^32",
    "quill": "^2.0.0",
    "rxjs": ">=7.8.0"
  },
  "dependencies": {
    "@material/animation": "^14.0.0",
    "@nx/devkit": "^22.5.1",
    "@phenomnomnominal/tsquery": "^6.1.3",
    "libphonenumber-js": "^1.10.48",
    "tslib": "^2.3.0"
  },
  "ng-update": {
    "migrations": "./migrations.json"
  },
  "exports": {
    "./scss/*": {
      "sass": "./scss/*.scss"
    },
    "./assets/*": {
      "default": "./assets/*"
    },
    "./migrations.json": "./migrations.json"
  },
  "backbase": {
    "design-system": "2026.03"
  }
}
